var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDocumentPen = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--transaction-history",
  width: 24,
  height: 24,
  viewBox: "0 0 160 160",
  ref: svgRef
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 120,
  width: 40,
  height: 10
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 100,
  width: 40,
  height: 10
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 80,
  width: 60,
  height: 10
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 60,
  width: 60,
  height: 10
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M158.54,66.46l-15-15a5,5,0,0,0-7.08,0L120,67.93v-30L82.07,0H0V160H120V112.07l38.54-38.53A5,5,0,0,0,158.54,66.46ZM147.93,70,145,72.93,137.07,65,140,62.07Zm-10,10-40,40H90v-7.93l40-40ZM85,17.07,102.93,35H85ZM110,150H10V10H75V45h35V77.93L81.46,106.46A5,5,0,0,0,80,110v15a5,5,0,0,0,5,5h15a5,5,0,0,0,3.54-1.46l6.46-6.47Z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDocumentPen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconDocumentPen.eaf96b16.svg";
export { ForwardRef as ReactComponent };